/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-06-04 22:12:01
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button, TextStyle } from '@shopify/polaris';
import { MobileCancelMajor } from '@shopify/polaris-icons';
import { withI18n } from '@shopify/react-i18n';
import { getShop, nowTimestamp } from 'src/helpers';
import { routes } from 'src/routes';
import history from 'src/routes/history';

import PersonalizationPresentBannerTagLine from 'src/assets/images/recommendation/personalization-present-banner-tagline.png';
import PersonalizationPresentBannerImage from 'src/assets/images/recommendation/personalization-present-banner.png';

const PersonalizationPresentBanner = props => {
  const { i18n, showWhenDismissed, selectedPlan } = props;
  const [dismissedBanner, setDismissedBanner] = useState(true);

  const getKeyDismiss = shop => `${shop}-dismissRecommendationPersonalizationPresentBanner`;

  const checkDismissedBanner = () => {
    const shop = getShop();

    const now = nowTimestamp();
    const startDate = 1717632000; // 00:00:00, Jun 6, 2024
    const endDate = 1718927999; // 23:59:59, Jun 20, 2024
    const isShowTime = now >= startDate && now <= endDate;

    if (!isShowTime || !selectedPlan.includes('professional')) {
      return;
    }

    try {
      const dismissed = localStorage.getItem(getKeyDismiss(shop));
      if (dismissed !== 'true') setDismissedBanner(false);
    } catch (error) {}
  };

  const onDismiss = () => {
    const shop = getShop();
    try {
      localStorage.setItem(getKeyDismiss(shop), true);
    } catch (error) {}

    setDismissedBanner(true);
  };

  const openLink = (id: string) => {
    history.push(routes.recommendationWidgets.newPersonalized());
    onDismiss();
  };

  useEffect(() => {
    checkDismissedBanner();
    // eslint-disable-next-line
  }, []);

  if (dismissedBanner) {
    return showWhenDismissed;
  }

  return (
    <div className={`RecommendationPersonalizationPresent-Banner-Container`}>
      <div className="banner-dismiss">
        <Button onClick={onDismiss} icon={MobileCancelMajor} plain />
      </div>
      <div className="banner-detail">
        <div className="banner-content">
          <div className="title">
            <img src={PersonalizationPresentBannerTagLine} alt="Personalization Present Banner" />
            {/* {i18n.translate('AdminHTML.Recommendation.PresentPersonalizationBanner.bannerTitle')} */}
          </div>
          <p>
            {i18n.translate('AdminHTML.Recommendation.PresentPersonalizationBanner.paragraph', {
              t1: (
                <TextStyle variation="strong">
                  {i18n.translate(
                    'AdminHTML.Recommendation.PresentPersonalizationBanner.paragraph_t1'
                  )}
                </TextStyle>
              )
            })}
          </p>
        </div>
        {/* Render image banner */}
        <div className="image">
          <img src={PersonalizationPresentBannerImage} alt="Personalization Present Banner" />
          <Button destructive onClick={openLink}>
            {i18n.translate(`AdminHTML.Recommendation.PresentPersonalizationBanner.action`)}
          </Button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  const tenantApp = _.get(state.oauth, 'tenantApp', {});
  const selectedPlan = _.get(tenantApp, 'selectedPlan', '');

  return {
    selectedPlan
  };
};

export default withI18n()(connect(mapStateToProps)(PersonalizationPresentBanner));
